export default {
      id: "ic_agf_info-usage",
      viewBox: "0 0 11 10",
      url: "/" + "images/icons.3.109.2.svg#ic_agf_info-usage",
      toString: function () {
        return this.url;
      }
    }